"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=TransformationHttpMethod.js.map